import { render } from "./Contracts.vue?vue&type=template&id=0cd6e43c"
import script from "./Contracts.js?vue&type=script&lang=js"
export * from "./Contracts.js?vue&type=script&lang=js"

import "./Contracts.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__